import { ReactNode } from 'react';

export interface AsideProps {
    /** Aside width (px number or CSS string). Defaults to the stylesheet width. */
    width?: number | string;
    children?: ReactNode;
}

/**
 * Right column content for StandardModal (e.g. secondary actions like "Save and Exit").
 */
export const Aside = ({ width, children }: AsideProps) => {
    return (
        <div
            className='standardModalAside'
            style={width !== undefined ? { flexBasis: width } : undefined}
        >
            {children}
        </div>
    );
};
